var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            width: "40%",
            "modal-append-to-body": false,
            "append-to-body": "",
          },
          on: { close: _vm.handleClose },
        },
        [
          _c("div", { staticClass: "basic-container" }, [
            _vm.data
              ? _c("div", [
                  _c(
                    "div",
                    _vm._l(_vm.data, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "data-container" },
                        [
                          _c("div", { key: index, staticClass: "left-key" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.name || "") +
                                "\n            "
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "right-content" },
                            [
                              item.isImage && item.value
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "100px",
                                      height: "100px",
                                    },
                                    attrs: {
                                      src: item.value,
                                      fit: "scale-down",
                                    },
                                  })
                                : _c(
                                    "span",
                                    { class: { blueText: item.name === " " } },
                                    [_vm._v(_vm._s(item.value || ""))]
                                  ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "bottom-center" },
            [
              _vm.slotControl.submitFooter
                ? _vm._t("submitFooter", null, null, _vm.data)
                : _vm._e(),
              _vm.slotControl.auditFooter
                ? _vm._t("auditFooter", null, null, _vm.data)
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }